import { SravniCustomersRatingListParams } from '../__generated__/reviews/reviewsApiTypes';
import { ISravniRating } from '../interfaces/ratings';

import ProxyClient from './clients/ProxyClient';

export const getSravniRating = async (params: SravniCustomersRatingListParams): Promise<ISravniRating[]> => {
  const { data } = await ProxyClient.get<ISravniRating[]>('/ratings/sravni', { params });
  return data;
};
